import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      // Context state (token + user) is now set — RequireAuth will pass
      const dest = location.state?.from?.pathname || "/dashboard";
      navigate(dest, { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ZoomPay" style={{height: "100px", width: "auto", margin: "0 auto"}} />
          <p className="text-blue-300 text-sm mt-2">Send Money to Africa, Instantly</p>
        </div>
      <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-8">
        <h1 className="text-2xl font-bold mb-1 text-center text-slate-900">Welcome Back</h1>
        <p className="text-center text-gray-500 text-sm mb-6">Sign in to your ZoomPay account</p>
        {error && (
          <p className="text-red-500 text-sm mb-3 text-center">{error}</p>
        )}
        <form onSubmit={handleLogin} className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              className="border p-2 w-full rounded"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Password</label>
            <input
              type="password"
              className="border p-2 w-full rounded"
              placeholder="\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button
            className="bg-blue-600 hover:bg-blue-700 transition text-white p-2 w-full rounded font-semibold disabled:opacity-60"
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
        <div className="text-center mt-6 space-y-2">
          <p className="text-blue-300 text-sm">
            Don't have an account?{' '}
            <a href="/register" className="text-amber-400 font-semibold hover:text-amber-300">Sign Up Free</a>
          </p>
          <p className="text-blue-300 text-sm">
            <a href="/forgot-password" className="text-blue-400 hover:text-blue-300">Forgot password?</a>
          </p>
          <p className="text-blue-400 text-xs mt-4">FINTRAC MSB C10001588 · ZoomPay Systems & Technology Ltd.</p>
        </div>
      </div>
    </div>
  );
}
